module.exports = __webpack_public_path__ + "img/profile.6bd1361c.png";